import { FleetRegistrationNoAuthService } from '@gen/driverPortal/fleetRegistrationNoAuth';
import { HttpClientBoltServer } from '@bolteu/http-client-bolt-server';
import { getAppBrand, getServerHost } from '../common/environment';
import { PORTAL_VERSION } from '../env';
import { DocumentsApiClient } from './types/apiTypes';

const documentsHttpClient =
  new HttpClientBoltServer<FleetRegistrationNoAuthService.HttpClientConstraints>(
    {
      baseUrl: getServerHost(),
    }
  );

documentsHttpClient.init({
  standardRequestStrategy: {
    getStandardRequest: () => {
      return {
        version: PORTAL_VERSION,
        brand: getAppBrand(),
      };
    },
  },
});

const documentsApiClient: DocumentsApiClient =
  new FleetRegistrationNoAuthService.ApiClient({
    httpClient: documentsHttpClient,
  });

export default documentsApiClient;
